import { menubar } from "./menubar";

export const gui = {
    namespaced: true,
    modules: {
        menubar
    }
};



// WEBPACK FOOTER //
// ./src/store/gui/gui.js